import { removeNonDigits } from './regex';

export const formatPhone = (value: string) => {
  const digits = value.replace(removeNonDigits, '').slice(0, 10);

  if (!digits) return '';

  let formatted =
    digits.length < 4 ? `(${digits}` : `(${digits.substring(0, 3)})`;

  if (digits.length >= 4) {
    formatted += ` ${digits.substring(3, Math.min(6, digits.length))}`;
  }

  if (digits.length >= 7) {
    formatted += `-${digits.substring(6, 10)}`;
  }

  return formatted;
};
